module.exports = __webpack_public_path__ + "media/B44.19997612.mp3";